import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API, saveAuthTokens } from '../App';

export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (code) {
      processMicrosoftAuth(code, state);
    } else {
      navigate('/login');
    }
  }, []);

  const processMicrosoftAuth = async (code, state) => {
    try {
      const redirectUri = window.location.origin + '/auth/microsoft/callback';
      const res = await API.post('/api/auth/microsoft/callback', { code, state, redirect_uri: redirectUri });
      saveAuthTokens(res.data);
      window.location.href = '/dashboard';
    } catch (err) {
      console.error('Microsoft auth failed:', err);
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#FF4D00] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A0A0A0] text-sm font-mono">Connecting Microsoft...</p>
      </div>
    </div>
  );
}
